import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';

// Rutas
import { APP_ROUTES } from './app.routes';

// Modulos
import { PagesModule } from './pages/pages.module';

//Interceptor
import { AuthInterceptor } from './services/interceptors/auth.interceptor';

// temporal
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

// Servicios
import { ServiceModule } from './services/service.module';

// Componentes
import { AppComponent } from './app.component';
import { LoginComponent } from './login/login.component';
import { LoginBaseComponent } from './loginbase/loginbase.component';
import { LoginVentusComponent } from './loginventus/loginventus.component';
import { LoginFliebenCapComponent } from './loginfliebencap/loginfliebencap.component';
import { LoginFliebenTresComponent } from './loginfliebentres/loginfliebentres.component';
import { LoginFacteaComponent } from './loginfactea/loginfactea.component';
import { LoginUnitaComponent } from './loginunita/loginunita.component';
import { LoginFacturacionComponent } from './loginfacturacion/loginfacturacion.component';
import { ResetpwdComponent } from './login/resetpwd.component';
import { ResetpwdBaseComponent } from './loginbase/resetpwdbase.component';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';

// [13/08/2026] Se retiró Bugsnag (@bugsnag/js y @bugsnag/plugin-angular): el dashboard no se revisaba hace ~1 año.
// Los errores de pagos/fondeo siguen visibles en console.log(err) dentro de cada catch.
import { HTTP_INTERCEPTORS } from '@angular/common/http';

@NgModule({
  declarations: [
    AppComponent,
    LoginComponent,
    LoginBaseComponent,
    ResetpwdComponent,
    ResetpwdBaseComponent,
    LoginVentusComponent,
    LoginFliebenCapComponent,
    LoginFliebenTresComponent,
    LoginFacteaComponent,
    LoginUnitaComponent,
    LoginFacturacionComponent
  ],
  imports: [
    BrowserModule,
    APP_ROUTES,
    PagesModule,
    FormsModule,
    ReactiveFormsModule,
    ServiceModule,
    BrowserAnimationsModule
  ],
  providers: [
    {
      provide: HTTP_INTERCEPTORS,
      useClass: AuthInterceptor,
      multi: true
    }
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }
